import { useCallback, useState } from "react";
import { Checkbox } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ListLayout, TableCard } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";

import { useCustomerValue } from "providers/CustomerContext";

import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import { getPickConfirmList } from "services/data.outbound.service";
import { resendPickConfirm } from "services/data.outbound.service";
import { CheckboxHeader, CheckboxCell } from "ui-components/tables/components/table";

function ShippedItems() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const enabled = Boolean(customerCode);
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);
  const [selectedIds, setSelectedIds] = useState([]);

  const editPermission =
    allowAll ||
    (Boolean(permissions["Shipped Items"]) &&
      permissions["Shipped Items"].findIndex((b) => b === "edit") !== -1);

  useQuery({
    queryKey: ["pick-confirm-list", { customerCode }],
    queryFn: () => getPickConfirmList({ customerCode }),
    enabled,
    onSuccess: (data) => setData(data.data.data),
    onError,
  });

  const resendMutation = useMutation(resendPickConfirm, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["pick-confirm-list"]);
      queryClient.invalidateQueries(["snt-status"])
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const columns = [
    {
      id: "select",
      header: CheckboxHeader,
      cell: CheckboxCell,
    },
    { header: "Cust Order Number", accessorKey: "custOrdNbr" },
    { header: "Pickslip Number", accessorKey: "pickslipNumber" },
    { header: "Error Message", accessorKey: "errorMessage" },
    {header:"Created On",accessorKey:"createdOn"},
    {header:"Updated On",accessorKey:"updatedOn"}
  ];
  const handleChange = useCallback((data) => {
    setSelectedIds(data);
  }, []);
  const onResend = () => {
    resendMutation.mutate({
      items: selectedIds.map((x) => ({ customerCode, pickslipNumber: x.pickslipNumber })),
    });
  };
  const resendStatus = resendMutation.status === "loading";
  return (
    <ListLayout>
      {resendStatus && <LoadingDialog />}
      <MDBox my={3}>{alert}</MDBox>
      <TableCard>
        <MDBox display="flex" justifyContent="space-between" alignItems="flex-start" margin="10px">
          <MDButton
            variant="gradient"
            color="info"
            onClick={onResend}
            disabled={(selectedIds.length === 0 || resendStatus) && !editPermission}
          >
            resend
          </MDButton>
        </MDBox>
        <CheckboxTable2 columns={columns} data={data} onSelectedRowsChange={handleChange} />
      </TableCard>
    </ListLayout>
  );
}

export default ShippedItems;
